import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type User = {
  id: string;
  email: string;
  created_at: string;
};

export type Wallet = {
  id: string;
  user_id: string;
  crypto: string;
  amount: number;
  created_at: string;
};

export type Transaction = {
  id: string;
  user_id: string;
  type: "buy" | "sell";
  crypto: string;
  amount: number;
  price: number;
  total: number;
  created_at: string;
};
